import React, { useRef, useEffect, useState } from 'react';
import { Slider } from '@mui/material';
import { formatAudioTime } from '@src/utils/time';
import { StyledBlockAudioPopover } from './BlockAudioPopover.style';

const BlockAudioPopover = ({
  open,
  currentTime,
  duration,
  audioLink,
  onSeek,
}) => {
  const [ownDuration, setOwnDuration] = useState(0);
  const audioRef = useRef(null);

  useEffect(() => {
    if (!audioLink) return undefined;

    const audio = document.createElement('audio');
    audio.preload = 'metadata';
    audio.addEventListener('loadedmetadata', () => {
      setOwnDuration(audio.duration);
    });
    audio.src = audioLink;
    audioRef.current = audio;

    return () => {
      audio.src = '';
      audioRef.current = null;
    };
  }, [audioLink]);

  // duration prop takes priority (when this block is actively playing),
  // otherwise use the duration loaded from audioLink
  const displayDuration = duration || ownDuration;

  if (!open) return null;

  return (
    <StyledBlockAudioPopover>
      <div className="popover-time">
        <span>
          {formatAudioTime(currentTime)}/{formatAudioTime(displayDuration)}
        </span>
      </div>
      <div className="popover-slider-wrapper">
        <Slider
          className="popover-slider"
          value={currentTime}
          min={0}
          max={displayDuration || 1}
          onChange={(_, value) => onSeek(value)}
          size="small"
        />
      </div>
    </StyledBlockAudioPopover>
  );
};

export default BlockAudioPopover;
